import { camelCase } from '../util.js'
const works = [
  {
    title: 'B9苏宁易购418down到谷底系列  江苏省第二十三届优秀广告作品  银奖',
    desc: 'B9苏宁易购418down到谷底系列  江苏省第二十三届优秀广告作品  银奖',
    thumb: camelCase('cases-brand-suning-0'),
    zpic: [
      camelCase('cases-brand-suning-lazyload-01'),
      camelCase('cases-brand-suning-lazyload-02'),
      camelCase('cases-brand-suning-lazyload-03'),
      camelCase('cases-brand-suning-lazyload-04'),
      camelCase('cases-brand-suning-lazyload-05')
    ]
  },
  {
    title: 'B9苏宁易购超市蓝瘦香菇系列 江苏省第二十三届优秀广告作品  银奖',
    desc: 'B9苏宁易购超市蓝瘦香菇系列 江苏省第二十三届优秀广告作品  银奖',
    thumb: camelCase('cases-brand-suning-5'),
    zpic: [
    ]
  },
  {
    title: 'B9苏宁易购超市蓝瘦香菇系列 江苏省第二十三届优秀广告作品  银奖',
    desc: 'B9苏宁易购超市蓝瘦香菇系列 江苏省第二十三届优秀广告作品  银奖',
    thumb: camelCase('cases-brand-suning-1'),
    zpic: [
      camelCase('cases-brand-suning--lazyload-11'),
      camelCase('cases-brand-suning--lazyload-12'),
      camelCase('cases-brand-suning--lazyload-13')
    ]
  },
  {
    title: 'B9苏宁易购超市蓝瘦香菇系列 江苏省第二十三届优秀广告作品  银奖',
    desc: 'B9苏宁易购超市蓝瘦香菇系列 江苏省第二十三届优秀广告作品  银奖',
    thumb: camelCase('cases-brand-suning-5'),
    zpic: [
    ]
  },
  {
    title: 'B9苏宁易购超市吐槽系列 第24届中国国际广告节 长城奖 铜奖',
    desc: 'B9苏宁易购超市吐槽系列 第24届中国国际广告节 长城奖 铜奖',
    thumb: camelCase('cases-brand-suning-2'),
    zpic: [
      camelCase('cases-brand-suning--lazyload-21'),
      camelCase('cases-brand-suning--lazyload-22'),
      camelCase('cases-brand-suning--lazyload-23'),
      camelCase('cases-brand-suning--lazyload-24')
    ]
  },
  {
    title: 'B9苏宁易购超市蓝瘦香菇系列 江苏省第二十三届优秀广告作品  银奖',
    desc: 'B9苏宁易购超市蓝瘦香菇系列 江苏省第二十三届优秀广告作品  银奖',
    thumb: camelCase('cases-brand-suning-5'),
    zpic: [
    ]
  },
  {
    title: 'A9苏宁易购双11病毒视频穿越篇 江苏省第二十三届优秀广告作品  金奖',
    desc: 'A9苏宁易购双11病毒视频穿越篇 江苏省第二十三届优秀广告作品  金奖',
    thumb: camelCase('cases-brand-suning-3'),
    zpic: [
      require('../../assets/cases-brand-suning-lazyload-31.mp4'),
      require('../../assets/cases-brand-suning-lazyload-32.mp4'),
      require('../../assets/cases-brand-suning-lazyload-33.mp4')
    ]
  },

  {
    title: 'B9苏宁易购418down到谷底系列  江苏省第二十三届优秀广告作品  银奖',
    desc: 'B9苏宁易购418down到谷底系列  江苏省第二十三届优秀广告作品  银奖',
    thumb: camelCase('cases-brand-suning-4'),
    zpic: [
      require('../../assets/cases-brand-suning-lazyload-41.mp4')
    ]
  }

]
export default {
  name: '苏宁',
  logo: {
    default: camelCase('cases-brand-5'),
    active: camelCase('cases-brand-5-cover')
  },
  works
}
